import InputContactPerson from './container';

export default InputContactPerson;
